// Copyright 2024 - MinIO, Inc. All rights reserved.

import React from "react";
import {
  Box,
  Button,
  FormLayout,
  InputBox,
  JSONIcon,
  KeyIcon,
  NewPathIcon,
  ProgressBar,
} from "mds";
import { useAppDispatch, useAppSelector } from "app/hooks";
import {
  setApiEndpoint,
  setApiPort,
  setStep,
  setUIEndpoint,
} from "./setupSlice";
import { finishSetupAsync } from "./setupThunks";

const SetupStep3 = () => {
  const dispatch = useAppDispatch();

  const uiEndpoint = useAppSelector((state) => state.setup.uiEndpoint);
  const apiEndpoint = useAppSelector((state) => state.setup.apiEndpoint);
  const apiPort = useAppSelector((state) => state.setup.apiPort);
  const status = useAppSelector((state) => state.setup.status);

  return (
    <Box sx={{ width: "100%" }}>
      <FormLayout withBorders={false} containerPadding={false}>
        <Box className={"inputItem"}>
          Please enter the endpoints that will be used to access{" "}
          <strong>the MinIO Enterprise Console</strong>
        </Box>

        <InputBox
          id={"consoleEndpoint"}
          placeholder="UI Endpoint"
          value={uiEndpoint}
          onChange={(e) => dispatch(setUIEndpoint(e.target.value))}
          startIcon={<NewPathIcon />}
          disabled={status === "loading"}
        />
        <InputBox
          id={"api-endpoint"}
          placeholder="API Endpoint"
          value={apiEndpoint}
          onChange={(e) => dispatch(setApiEndpoint(e.target.value))}
          startIcon={<KeyIcon />}
          disabled={status === "loading"}
        />

        <InputBox
          id={"api-port"}
          placeholder="API Port"
          value={apiPort}
          onChange={(e) => dispatch(setApiPort(parseInt(e.target.value, 10)))}
          startIcon={<JSONIcon />}
          disabled={status === "loading"}
        />
        {status === "loading" && <ProgressBar />}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 12 }}>
          <Button
            id={"register"}
            type={"button"}
            onClick={() => {
              dispatch(setStep(2));
            }}
          >
            Back
          </Button>
          <Button
            id={"register"}
            type={"button"}
            onClick={() => dispatch(finishSetupAsync())}
            disabled={status === "loading"}
            variant={"callAction"}
          >
            Finish Setup
          </Button>
        </Box>
      </FormLayout>
    </Box>
  );
};

export default SetupStep3;
